import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { type Location, useLocation } from 'react-router';
import { getConfig } from '@/constants/config';
import { useAcknowledgeTermsAndConditionsMutation } from '@/domains/products/hooks/useShowTermsAndConditionsUpdate/useAcknowledgeTermsAndConditionsMutation';
import useModal from '@/hooks/useModal';
import { usersMeQueryOptions } from '@/queries/usersMeQuery';
const useShowTermsAndConditionsUpdate = () => {
  const location = useLocation() as Location<{ from?: string }>;
  const { openModal, closeModal, isModalOpen } = useModal();
  const { data: usersMe } = useQuery(usersMeQueryOptions());
  const [hasModalBeenOpened, setHasModalBeenOpened] = useState(false);
  const { mutate: acknowledgeTermsAndConditions } = useAcknowledgeTermsAndConditionsMutation();

  const isNavigatingFromLogin = location.state?.from === getConfig().internalLinks.loginSuccess;

  const shouldOpenModal =
    isNavigatingFromLogin &&
    usersMe &&
    !usersMe.isLatestTermsAndConditionsAcknowledged &&
    !isModalOpen &&
    !hasModalBeenOpened;

  useEffect(() => {
    if (shouldOpenModal) {
      openModal('TERMS_AND_CONDITIONS_UPDATED', {
        isPersistedFromRedirect: true,
        closeAction: () => {
          acknowledgeTermsAndConditions();
          closeModal();
        },
      });
      setHasModalBeenOpened(true);
    }
  }, [acknowledgeTermsAndConditions, closeModal, openModal, shouldOpenModal]);
};

export default useShowTermsAndConditionsUpdate;
